// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2Cftu","errors":"Errors_errors__rI7m6"};